import type { LivenessStage } from "@aidkitorg/aidkit/lib/application/liveness.schema";

export type LivenessPartKey = "front" | "back" | "selfie"

export type LivenessPart = {
  imageUrl?: string,
  videoUrl?: string,
  uploading?: false,
  videoUpload?: number,
  imageUpload?: number,
  failedToUpload?: boolean
}

export type LivenessState = Record<LivenessPartKey, LivenessPart>

export type { LivenessStage };
export type { LivenessDetection } from "@aidkitorg/types/lib/survey";

/**
 * Where legal, adds "-captured" to a LivenessPart key to generate the next LivenessStage
 */
export const addLivenessStageCaptured = (incoming: LivenessStage): LivenessStage => {
  switch(incoming) {
    case "front":
      return "front-captured";
    case "back":
      return "back-captured";
    case "selfie":
      return "selfie-captured";
    default:
      return incoming;
  }
}

/**
 * Where legal, removes "-captured" to a LivenessPart key to generate the previous LivenessStage
 */
export const removeLivenessStageCaptured = (incoming: LivenessStage): LivenessStage => {
  switch(incoming) {
    case "front-captured":
      return "front";
    case "back-captured":
      return "back";
    case "selfie-captured":
      return "selfie";
    default:
      return incoming;
  }
}

export const isLivenessStageCaptured = (stage: LivenessStage): stage is 'front-captured' | 'back-captured' | 'selfie-captured' => {
  return Boolean(['front-captured', 'back-captured', 'selfie-captured'].includes(stage));
}
